import { addDays, format, parseISO } from 'date-fns';
import React from 'react';
export const columns = [
  {
    name: <span title="Funcionalidade">Funcionalidade</span>,
    selector: (row) => row.description,
    width: '240px',
  },
  {
    name: <span title="Quantidade">Quantidade</span>,
    selector: (row) => row.count,
  },
  {
    name: <span title="Adicionado em">Adicionado em</span>,
    selector: (row) =>
      row.createdAt ? format(parseISO(row.createdAt), 'dd/MM/yyyy') : '',
    width: '150px',
  },
  {
    name: <span title="Origem">Origem</span>,
    selector: (row) => row?.origin || '-',
  },
  {
    name: <span title="Valido até">Valido até</span>,
    selector: (row) =>
      row.validUntil ? format(parseISO(row.validUntil), 'dd/MM/yyyy') : '',
  },
  {
    name: <span title="Motivo da liberação">Motivo da liberação</span>,
    selector: (row) => row?.releaseReason || 'Não informado',
    width: '270px',
  },
  {
    name: <span title="Nome do admin">Liberado por</span>,
    selector: (row) => row?.releasedBy || '-',
    width: '250px',
  },
  {
    name: <span title="Final do cartão">Final do cartão</span>,
    selector: (row) => row?.cardLastFourDigits || '-',
    width: '140px',
  },
  {
    name: <span title="Valor pago">Valor pago</span>,
    selector: (row) => row?.paidAmount || 0,
  },
  {
    name: 'Id da transação',
    selector: (row) => row?.transactionId || '-',
  },
];

export const ACTIVE_TABS = {
  BILHETAGEM: 'bilhetagem',
  OUTROS: 'outros',
};

export const BENEFITS_TABS_CONFIG = {
  [ACTIVE_TABS.BILHETAGEM]: {
    path: '/subscription/benefits',
    errorMessage:
      'Ocorreu um erro ao carregar os benefícios de calculadoras e consultas.',
  },
  [ACTIVE_TABS.OUTROS]: {
    path: '/subscription/benefits/legacy',
    errorMessage: 'Ocorreu um erro ao carregar os outros benefícios.',
  },
};
export const DATE_INITIAL = format(addDays(new Date(), 3), 'yyyy-MM-dd');
export const JUSZAP_STATUS_MAP = {
  STARTED: {
    label: 'Iniciado',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-hourglass-start',
  },
  WAITING_FOR_SETTINGS: {
    label: 'Aguardando Configuração',
    color: '#8950FC',
    bgColor: '#EEE5FF',
    icon: 'fas fa-cog',
  },
  COMPLETED: {
    label: 'Completo',
    color: '#01AB7D',
    bgColor: '#E6F7F2',
    icon: 'fas fa-check-circle',
  },
  UPDATE_REQUIRED: {
    label: 'Atualização Necessária',
    color: '#F64E60',
    bgColor: '#FFE2E5',
    icon: 'fas fa-exclamation-triangle',
  },
  CANCELLED: {
    label: 'Cancelado',
    color: '#B5B5C3',
    bgColor: '#F3F3F3',
    icon: 'fas fa-ban',
  },
};

export const JUSMAIL_STATUS_MAP = {
  CREATED: {
    label: 'Criado',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-plus-circle',
  },
  ORDERED: {
    label: 'Solicitado',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-shopping-cart',
  },
  ACCEPTED: {
    label: 'Aceito',
    color: '#8950FC',
    bgColor: '#EEE5FF',
    icon: 'fas fa-thumbs-up',
  },
  REGISTERED: {
    label: 'Registrado',
    color: '#8950FC',
    bgColor: '#EEE5FF',
    icon: 'fas fa-clipboard-check',
  },
  VERIFICATION_PENDING: {
    label: 'Verificação Pendente',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-clock',
  },
  VERIFICATION_FAILED: {
    label: 'Verificação Falhou',
    color: '#F64E60',
    bgColor: '#FFE2E5',
    icon: 'fas fa-times-circle',
  },
  VERIFIED: {
    label: 'Verificado',
    color: '#3699FF',
    bgColor: '#E1F0FF',
    icon: 'fas fa-shield-alt',
  },
  SAML_PENDING: {
    label: 'SAML Pendente',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-key',
  },
  READY: {
    label: 'Pronto',
    color: '#01AB7D',
    bgColor: '#E6F7F2', 
    icon: 'fas fa-check-circle',
  },
  CANCELLED: {
    label: 'Cancelado',
    color: '#B5B5C3',
    bgColor: '#F3F3F3',
    icon: 'fas fa-ban',
  },
  RENEWING: {
    label: 'Renovando',
    color: '#8950FC',
    bgColor: '#EEE5FF',
    icon: 'fas fa-sync-alt',
  },
  EXPIRED: {
    label: 'Expirado',
    color: '#F64E60',
    bgColor: '#FFE2E5',
    icon: 'fas fa-calendar-times',
  },
  DISABLED: {
    label: 'Desativado',
    color: '#B5B5C3',
    bgColor: '#F3F3F3',
    icon: 'fas fa-minus-circle',
  },
};

// JusCont — status de PAGAMENTO da contratação (juspage-backend: GET /api/juscont/status)
export const JUSCONT_STATUS_MAP = {
  WAITING_PAYMENT: {
    label: 'Aguardando Pagamento',
    color: '#FFA800',
    bgColor: '#FFF4DE',
    icon: 'fas fa-clock',
  },
  PAYMENT_ERROR: {
    label: 'Erro no Pagamento',
    color: '#F64E60',
    bgColor: '#FFE2E5',
    icon: 'fas fa-times-circle',
  },
  PAID: {
    label: 'Pago',
    color: '#01AB7D',
    bgColor: '#E6F7F2',
    icon: 'fas fa-check-circle',
  },
  CANCELLED: {
    label: 'Cancelado',
    color: '#B5B5C3',
    bgColor: '#F3F3F3',
    icon: 'fas fa-ban',
  },
};

export const JUSCONT_PLAN_LABELS = {
  JUSCONT_BASICO: 'Básico',
  JUSCONT_PROFESSIONAL: 'Professional',
  JUSCONT_PREMIUM: 'Premium',
};

export const JUSCONT_ORIGIN_LABELS = {
  ADDON: 'Addon',
  PLAN: 'Incluso no plano',
};

export const JUSCONT_BILLING_CYCLE_LABELS = {
  MONTHLY: 'Mensal',
  ANNUAL: 'Anual',
};
